
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { getExtUserApiManagePageAPI } from './api'
import { toResult } from '@/utils/toResult'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'RuimingUserApiManagement',
  setup() {
    const data = reactive({
      loading: true,
      iframeUrl: ''
    })

    const onIframeLoad = () => {
      data.loading = false
    }

    const fetchIframeUrl = async () => {
      try {
        const [err, res] = await toResult(getExtUserApiManagePageAPI())
        if (err) {
          data.loading = false
          return
        }
        data.iframeUrl = res || ''
        if (!data.iframeUrl) {
          ElMessage.error('未获取到用户API管理链接')
          data.loading = false
        }
      } catch (error) {
        data.loading = false
        console.error('获取用户API管理链接失败:', error)
      }
    }

    onMounted(() => {
      fetchIframeUrl()
    })

    return {
      ...toRefs(data),
      onIframeLoad
    }
  }
})
